import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useLogout } from "./Identity/useLogout.js";
const defaultComponent = ({ onClick, children }) => /* @__PURE__ */ jsx("a", { href: "#", onClick, children });
const LogoutLink = memo((props) => {
  const onLogout = useLogout();
  const Component = props.Component || defaultComponent;
  return /* @__PURE__ */ jsx(Component, { onClick: onLogout, children: props.children });
});
LogoutLink.displayName = "LogoutLink";
export {
  LogoutLink
};
//# sourceMappingURL=LogoutLink.js.map
